module.exports = __webpack_public_path__ + "img/warning-icon.b584fa19.svg";